

import React, { useState ,useEffect} from 'react';
import { Card, Dropdown, Button, Row , Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useLoading } from '../components/LoadingProvider';

import ReminderStats from './reports/ReminderStats';

import { myReminders } from '../services/userPlants/userPlantsService'; 

import Util from '../components/Util'


const BASE_URL = process.env.REACT_APP_BASE_URL;

const MyRemindersPage = () => {
  const navigate = useNavigate();
 

  const [reminders, setReminders] = useState([]);
  const [maxReminder, setMaxReminder] = useState(0);
  const [validDueDate, setValidDueDate] = useState(null);
 

    const { showLoading, hideLoading, toast } = useLoading();

  useEffect(()=>{

    showLoading();

    myReminders()
    .then(data=> {
      console.log(data);



      setReminders(data.list)
      setMaxReminder(data.maxReminder);
      setValidDueDate(data.validDueDate);


    })
    .catch(err=>{
      console.log(err);
      toast.error('خطایی رخ داد. در صورت تکرار با مدیر سایت تماس بگیرید');

    })
    .finally(()=>{
      hideLoading();
    });

  },[]);

  const handleToggleActive = (id) => {
    setReminders((prev) =>
      prev.map((r) =>
        r.id === id ? { ...r, isActive: !r.isActive } : r
      )
    );
  };

  const handleEdit = (id) => {
    navigate(`/reminder/${id}`);
  };

  const handleDelete = (id) => {
    setReminders((prev) => prev.filter((r) => r.id !== id));
  };

  

  return (
    <div className="container mt-4">
      <h4 className="mb-4">یادآوری‌های من</h4>

        <Row>
            <Col>
            
                <ReminderStats validDueDate={ Util.timeUntil(  validDueDate )} maxReminder={maxReminder} reminders={reminders} />

            
            </Col>
            
        </Row>
        

      {reminders.map((reminder) => (
        <Card className="mb-3 position-relative" key={reminder.id}>
          <div className="row g-0">
            <div className="col-md-3 image-footer-parent">
              <Card.Img src={BASE_URL + reminder.image} alt={reminder.plantName} />

             <div className='image-footer'>
                  <p> <b> {reminder.plantName} </b>  </p>
                  <p> {reminder.plantGroupName}  </p>
             </div>

            </div>
            <div className="col-md-9">
              <Card.Body>
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <Card.Title>{reminder.MyTitle || 'N/A'}</Card.Title>
                    {reminder.note && (
                      <Card.Subtitle className="mb-2 text-muted">
                        {reminder.note}
                      </Card.Subtitle>
                    )}
                    {reminder.isActive && (
                      <div className="text-success mt-2">
                        <strong>آبیاری بعدی:</strong>  
                        <span title={reminder.nextWatering}> { Util.timeUntil(reminder.nextWatering).message } </span>  
                      </div>
                    )}
                    {!reminder.isActive && (
                      <div className="text-muted mt-2">یادآور غیرفعال است</div>
                    )}
                  </div>

                  {/* دکمه سه‌نقطه */}
                  <Dropdown align="end">
                    <Dropdown.Toggle
                      variant="light"
                      className="border-0 p-0"
                      style={{ fontSize: '1.5rem' }}
                    >
                      ⋮
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {/* <Dropdown.Item onClick={() => handleEdit(reminder.id)}>
                        ویرایش یادآور
                      </Dropdown.Item> */}
                      <Dropdown.Item
                        onClick={() => handleToggleActive(reminder.id)}
                      >
                        {reminder.isActive
                          ? 'غیرفعال کردن یادآور'
                          : 'فعال‌سازی یادآور'}
                      </Dropdown.Item>
                      {/* <Dropdown.Divider />
                      <Dropdown.Item
                        className="text-danger"
                        onClick={() => handleDelete(reminder.id)}
                      >
                        حذف یادآور
                      </Dropdown.Item> */}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </Card.Body>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default MyRemindersPage;
